// Shared option lists for the Users page category filters (Religion / Caste /
// Gender / Divyang). Mirrors the lists already used in EditUserDialog.jsx —
// kept as a separate file rather than importing from there, so this page's
// filters can't accidentally regress that form.

export const GENDERS = ['Male', 'Female', 'Other'];

export const RELIGIONS = ['Hindu', 'Muslim', 'Christian', 'Sikh', 'Buddhist', 'Jain', 'Parsi', 'Jewish', 'Other'];

export const CASTE_BY_RELIGION = {
  Hindu: ['Brahmin', 'Kshatriya', 'Vaishya', 'Shudra', 'Kayastha', 'Khatri', 'Maratha', 'Jat', 'Yadav', 'Rajput', 'Other'],
  Muslim: ['Sunni', 'Shia', 'Ahmadiyya', 'Other'],
  Christian: ['Catholic', 'Protestant', 'Orthodox', 'Other'],
  Sikh: ['Jat', 'Khatri', 'Ramgarhia', 'Other'],
  Buddhist: ['Mahayana', 'Theravada', 'Vajrayana', 'Other'],
  Jain: ['Digambar', 'Shwetambar', 'Other'],
  Parsi: ['Parsi', 'Irani', 'Other'],
  Jewish: ['Ashkenazi', 'Sephardic', 'Other'],
  Other: ['Other'],
};

export const DISABILITY_OPTIONS = [
  'None',
  'Physically disabled from birth',
  'Physically disabled due to accident',
  'Mentally disabled from birth',
  'Mentally disabled due to accident',
  'Thalassemia',
  'HIV+',
];
